import { ApolloError } from '@apollo/client';

import {
  IPaginationProps,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { RetailerNetworkPartialFragment } from '@occc/graphql';

import { RetailerNetworkListTableRow } from './retailer-network-list-table-row.component';

type RetailerNetworkListTableProps = {
  data?: RetailerNetworkPartialFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  onNetworkClick?: (uuid: string) => void;
};

export const RetailerNetworkListTable = ({
  data,
  loading,
  error,
  paginationProps,
  onNetworkClick,
}: RetailerNetworkListTableProps) => {
  const renderData = (items: RetailerNetworkPartialFragment[]) => {
    const rows = items.map((item) => (
      <RetailerNetworkListTableRow key={item.uuid} item={item} onClick={onNetworkClick} />
    ));

    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Network Name</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Network Admin</TableCell>
              <TableCell>Locations</TableCell>
              <TableCell align='right'>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </TableContainer>
    );
  };

  return (
    <LoadedContent<RetailerNetworkPartialFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};
